let _s = localStorage.getItem("ccy") || "€";
export const setCurrency = (x) => { if (x) { _s = x; localStorage.setItem("ccy", x); } };
export const sym = () => _s;
